// Leaflet rendering mode — MUST run before any leaflet import.
//
// Foldables (Galaxy Z Fold 7/8 in tablet mode) and some Android GPUs glitch
// hard with Leaflet's default translate3d-accelerated panes: tiles composite
// as black rectangles and the whole page flashes as the compositor thrashes
// layers. L_DISABLE_3D forces plain 2D transforms — no per-tile GPU layers,
// no black frames. Panning stays smooth in practice; correctness wins.
window.L_DISABLE_3D = true;
